export default {
  tableHeader: 'Anlagesignale',
  showHidden: 'Versteckte Anlagesignale anzeigen',
  overFlowMenu: {
    tooltip: 'Weitere Funktionen',
    export: 'Export Sensor-Einstellungen',
    import: 'Import Sensor-Einstellungen',
  },
  placeholder: {
    meaningId: 'Bedeutung auswählen',
    meaningInstanceNumber: 'Instanz-Nr.',
  },
};
